var styles = {"smaller":"gWgLCEdx90Q-","small":"NukXJ1ku9MQ-","base":"D2y5sdKc6Hs-"};

export { styles as default };
//# sourceMappingURL=Icon.module.css.js.map
